import React from 'react';
import { Github, Linkedin, X } from 'lucide-react';

const Footer = () => {
  const socials = [
    { icon: <Github className="w-4 h-4" />, url: 'https://github.com/KajetanJedrych', label: 'GitHub' },
    { icon: <Linkedin className="w-4 h-4" />, url: 'https://www.linkedin.com/in/kajedrych/', label: 'LinkedIn' },
    { icon: <X className="w-4 h-4" />, url: 'https://x.com/jkajtek', label: 'X' },
  ];

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 py-5">
        <div className="flex flex-wrap justify-between items-center gap-4">
          <a href="https://www.jedrychk.com/" className="text-lg font-bold tracking-tight">
            <span className="text-violet-400">Kajetan </span>
            <span className="text-slate-100">Jedrych</span>
          </a>

          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} Kajetan Jedrych · Website by{' '}
            <a
              href="https://kjweb.pl/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-violet-400 transition-colors duration-200"
            >
              kjweb.pl
            </a>
          </p>

          <div className="flex items-center gap-3">
            {socials.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                className="p-2 bg-slate-800 border border-slate-700 rounded-lg text-slate-400 hover:text-violet-400 hover:border-violet-500/40 transition-all duration-200 hover:scale-110"
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
